import { Flex } from '@rebass/grid';
import PropTypes from 'prop-types';

import { Image } from 'app/shared/ui';

export const GridItem = ({ iconName, children }) => (
  <Flex>
    <Image
      size="80px"
      alt={`${iconName}-icon`}
      src={`/assets/tradein/${iconName}.svg`}
      mr={16}
    />
    {children}
  </Flex>
);

GridItem.propTypes = {
  iconName: PropTypes.string.isRequired,
  children: PropTypes.node,
};

GridItem.defaultProps = { children: null };
